import { Swiper } from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';

const sectionTextMedia = document.querySelectorAll('section.text-media');

document.addEventListener('DOMContentLoaded', () => {
	sectionTextMedia.forEach((section) => {
		if (section.querySelector('.swiper-gallery')) {
			const sectionId = section.getAttribute('id');
			const swiperId = `#${sectionId} .swiper-gallery`;
			const swiperElement = document.querySelector(swiperId);
			const navigation = swiperElement.getAttribute('data-navigation') === '1';

			let swiperSettings = {
				modules: [Navigation, Pagination, A11y],
				a11y: true,
				grabCursor: true,
				height: 400,
				loop: true,
				slidesPerView: 1,
				spaceBetween: 16,
				freeMode: false,
				speed: 400,
				keyboard: {
					enabled: true,
				},
				navigation: {
					nextEl: `#${sectionId} .swiper-btn-next`,
					prevEl: `#${sectionId} .swiper-btn-prev`,
				},
				pagination: {
					el: `#${sectionId} .swiper-pagination`,
					clickable: true,
				},
			};

			if (!navigation) {
				swiperSettings.freeMode = true;
				swiperSettings.speed = 10000;
				swiperSettings.autoplay = {
					delay: 0.5,
					pauseOnMouseEnter: false,
				};
			}

			const swiper = new Swiper(swiperId, swiperSettings);
		}
	});
});
